import { ReactElement } from 'react'
import { Button, Loader } from 'semantic-ui-react'

import {SemanticSIZES} from 'semantic-ui-react';

import styles from './PrimaryActionButton.module.css'

interface PrimaryActionButtonProps {
    color?: string;
    children?: ReactElement | string;
    label?: string;
    disabled?: boolean;
    size?: SemanticSIZES;
    fluid?: boolean;
    onClick: (e: any) => void;
    loading?: any;
}

export default function PrimaryActionButton({ color, children, label, fluid, disabled, size = 'large', onClick, loading }: PrimaryActionButtonProps) {
    return (
        <Button className={styles.button} size={size} fluid={fluid} onClick={onClick} loading={loading}>
            {label}
            {children}
        </Button>
    )
}